import { useDispatch, useSelector } from "react-redux"
import { MainTabContentActiveTab, MainTabContentTabList } from "../../../actions/SidebarAction";
import { MainBarActiveTabsAction } from "../../../actions/MainBarActiveTabsAction";
// import Submission from "../../Billing/Submission/Submission";
// import Realtime from "../../Billing/Realtime/Realtime"
// import AccountReceivable from "../../Billing/AccountReceivables/AccountReceivable";
// import Statements from "../../Billing/Statements/Statements ";
// import Report from "../../Reports/Report";
// import EDIReports from "../../Billing/EDI Reports/EDIReports";
// import Payments from "../../Billing/Payments/Payments";
// import TaskManagement from "../../Home/TaskManagement/TaskManagement";
import { TabActionClaims, TabActionPayments } from "../../../actions/BillingActions";
import { lazy, useState } from "react";
import WriteOffReport from "../../Reports/FinancialReports/WriteOffReport";
import OverPaymentReport from "../../Reports/FinancialReports/OverPaymentReport";
import Patient from "../../Patient/Patient";
import { TabActionPatient } from "../../../actions/PatientActions";
import PatientSearch from "../../Patient/PatientSearch";
import EncounterMenuSearch from "../../Encounter Menu/EncounterMenuSearch";
const Claims = lazy(() => import("../../Billing/Claims/Claims"));
const Submission = lazy(() => import("../../Billing/Submission/Submission"));
const Realtime = lazy(() => import("../../Billing/Realtime/Realtime"))
const AccountReceivable = lazy(() => import("../../Billing/AccountReceivables/AccountReceivable"));
const Statements = lazy(() => import("../../Billing/Statements/Statements "));
const Report = lazy(() => import("../../Reports/Report"));
const EDIReports = lazy(() => import("../../Billing/EDI Reports/EDIReports"));
const Payments = lazy(() => import("../../Billing/Payments/Payments"));
const TaskManagement = lazy(() => import("../../Home/TaskManagement/TaskLayout/TaskTopLeftContent"));

const useSidebarSubMainTab = () => {
    let dispatch = useDispatch();
    let state = useSelector(state => state.SidebarList)
    const [recordsNum, setRecordsNum] = useState(false);


    const openSideBarSubActiveTab = (name, activeTabKey, searchField) => {
        console.log(searchField, 'searchField');

        //// Expects "" around value which is Aplphanumeric in searchField
        const parsedSearchField = searchField ? JSON.parse(searchField) : undefined;
        dispatch(MainBarActiveTabsAction({ [name]: { ActiveTabKey: activeTabKey, SearchField: parsedSearchField } }));
    }
    const handleSideBarTab = (name, parsedSearchField) => {

        const openSideBarTab = (key, name, component, right) => {
            let arr = state
            let dynamicTabs = [...arr]
            const newTabObject = {
                key: key,
                name: name,
                component: component,
                right: right,
                time: new Date(),
            }
            const isTabExist = dynamicTabs.filter((tab) => {
                return tab.name === name
            })
            if (!(isTabExist && isTabExist.length > 0)) {
                dynamicTabs = [...dynamicTabs, newTabObject]
                dispatch(MainTabContentTabList(dynamicTabs));
            }
            dispatch(MainTabContentActiveTab(key))
        }
        switch (name) {

            case 'TaskManagement':
                openSideBarTab(12, 'Task', <TaskManagement SearchField={parsedSearchField} />, true);
                break;

            case 'Reports':
                openSideBarTab(4, 'Reports', <Report />, true);
                break;

            case 'Submission':
                openSideBarTab(72, 'Submission', <Submission />, true);
                break;

            case "Claims":
                openSideBarTab(71, 'Claims', <Claims />, true);
                dispatch(TabActionClaims({
                    active: true,
                    key: 2,
                    name: "Claims",
                    data: {
                        name: "All Claims",
                        id: 0,
                        time: new Date()
                    },
                }));
                break;

            case 'Payments':
                openSideBarTab(73, 'Payments', <Payments />, true);
                dispatch(TabActionPayments({
                    active: true,
                    key: 2,
                    name: "Payments",
                    data: {
                        name: "All Payments",
                        id: 0,
                        time: new Date()
                    },
                }));
                break;

            case 'EDI Reports':
                openSideBarTab(78, 'EDI Reports', <EDIReports />, true);
                break;

            case 'Realtime':
                openSideBarTab(74, 'Realtime', <Realtime />, true);
                break;

            case 'Account Receivables':
                openSideBarTab(75, 'Account Receivables', <AccountReceivable SearchField={parsedSearchField} />, true);
                break;

            case 'Statements':
                openSideBarTab(76, 'Statements', <Statements />, true);
                break;

            case 'Write Off':
                openSideBarTab(77, 'Write Off', <WriteOffReport SearchField={parsedSearchField} />, true);
                break;

            case 'Over Payment':
                openSideBarTab(79, 'Over Payment', <OverPaymentReport SearchField={parsedSearchField} />, true);
                break;
            case 'Patient':
                openSideBarTab(2, 'Patient', <Patient SearchField={parsedSearchField} />, true);
                dispatch(TabActionPatient({
                    active: true,
                    key: 2,
                    name: "Patient",
                    data: {
                        name: "All Patient",
                        id: 0,
                        time: new Date()
                        // component: <PatientSearch />,
                    },
                }))
                break;
            case 'EncounterMenu':
                openSideBarTab(2, 'EncounterMenu', <EncounterMenuSearch setRecordsNum={setRecordsNum} SearchField={parsedSearchField} />, true);
                break;
            // case 'TaskEncounter':
            //     openSideBarTab(12, 'Task', <TaskManagement  SearchField={parsedSearchField} />, true);
            //     break;
        }
    }
    const openSidebarSubMainTab = (val) => {
        let [name, activeTabKey, searchField] = val.split('-');
        handleSideBarTab(name);
        openSideBarSubActiveTab(name, parseInt(activeTabKey), searchField);
    }
    return openSidebarSubMainTab;
}
export default useSidebarSubMainTab